import React from 'react';
import { Breadcrumbs, Paper, Typography } from '@mui/material';

const SupplementalDocument = ({ document = {} }) => {
  if (!document?.src) {
    return 'Document not found.';
  }

  const src = decodeURIComponent(document.src);

  return (
    <>
      <Breadcrumbs aria-label="Breadcrumbs">
        <Typography color="textSecondary" variant="h6">
          {document.title}
        </Typography>
      </Breadcrumbs>

      <Paper
        sx={{
          marginTop: 1,
          marginBottom: 1,
          padding: { xs: 1, sm: 2 },
        }}
        elevation={24}
      >
        <object
          type="application/pdf"
          data={`${src}#toolbar=0&navpanes=0`}
          title={document.title}
          style={{ border: 'none', width: '100%', height: '80vh' }}
        >
          <div>
            PDF viewer not supported by your browser. Download it <a href={src}>here</a>
          </div>
        </object>
      </Paper>
    </>
  );
};

export default SupplementalDocument;
